import {
  CLEAR_API_STATUS,
  GET_MAPPING_DATA,
  IS_SIGNATURE_UPLOADED_STATUS,
  PDF_AND_PAGE_DETAILS,
  UPDATE_FILTER,
  VALIDATE_USER_STATUS,
} from "./types";
import { errorMessage } from "../../constants/responseMessages";
import MappingService from "../../services/mappingService";
import { API_STATUS } from "../auth/types";
import { initialState } from "../auth/initialState";

const service = new MappingService();

export const clearApiStatus = () => {
  return (dispatch) => {
    dispatch({
      type: CLEAR_API_STATUS,
      payload: {},
    });
  };
};

export const getMappingData = (projectId, forValue) => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS,
      payload: { ...initialState?.apiStatus, loader: true },
    });
    dispatch({
      type: PDF_AND_PAGE_DETAILS,
      payload: {},
    });
    dispatch({
      type: GET_MAPPING_DATA,
      payload: [],
    });
    service
      .getMappingData(projectId, forValue)
      .then((res) => {
        dispatch({
          type: API_STATUS,
          payload: { ...initialState?.apiStatus, loader: false },
        });

        dispatch({
          type: GET_MAPPING_DATA,
          payload: res.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS,
          payload: {
            ...initialState?.apiStatus,
            loader: false,
            message: errorMessage(error),
          },
        });
      });
  };
};

export const validateUserClear = () => {
  return (dispatch) => {
    dispatch({
      type: VALIDATE_USER_STATUS,
      payload: {},
    });
  };
};

export const rejectMappingData = (data) => {
  // columnsCount used in free-form only
  return (dispatch) => {
    !data.autosave === true &&
      dispatch({
        type: API_STATUS,
        payload: { ...initialState?.apiStatus, loader: true },
      });
    service
      .rejectMappingData(data)
      .then((res) => {
        !data.autosave === true &&
          dispatch({
            type: API_STATUS,
            payload: {
              ...initialState?.apiStatus,
              loader: false,
              next: data?.next,
              isRejected: true,
            },
          });
        if (data.onSaveSuccess) {
          data.onSaveSuccess();
        }
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS,
          payload: {
            ...initialState?.apiStatus,
            loader: false,
            message: errorMessage(error),
          },
        });
      });
  };
};

export const validateMapping = (data) => {
  // columnsCount used in free-form only
  return (dispatch) => {
    !data.autosave === true &&
      dispatch({
        type: API_STATUS,
        payload: { ...initialState?.apiStatus, loader: true },
      });
    service
      .validateMapping(data)
      .then((res) => {
        !data.autosave === true &&
          dispatch({
            type: API_STATUS,
            payload: {
              ...initialState?.apiStatus,
              loader: false,
              next: data?.next,
              nextStep: true,
              message: res?.data?.message,
              isError: false,
            },
          });
        if (data.onSaveSuccess) {
          data.onSaveSuccess();
        }
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS,
          payload: {
            ...initialState?.apiStatus,
            loader: false,
            message: errorMessage(error),
            isError: true,
          },
        });
      });
  };
};

export const submitEsignBatch = (userName, userId, userRole, userPassword) => {
  return (dispatch) => {
    dispatch({
      type: VALIDATE_USER_STATUS,
      payload: { message: "", loader: true },
    });
    service
      .esignHandle(userName, userId, userRole, userPassword)
      .then((json) => {
        dispatch({
          type: VALIDATE_USER_STATUS,
          payload: { message: "", loader: false, next: true, setSuccess: true },
        });
      })
      .catch((error) => {
        dispatch({
          type: VALIDATE_USER_STATUS,
          payload: {
            message: errorMessage(error),
            loader: false,
            setError: true,
          },
        });
      });
  };
};

export const pageRedirection = (data) => {
  return (dispatch) => {
    dispatch({
      type: PDF_AND_PAGE_DETAILS,
      payload: {
        data,
      },
    });
  };
};

export const isSignatureUploaded = () => {
  return (dispatch) => {
    dispatch({
      type: IS_SIGNATURE_UPLOADED_STATUS,
    });
    service
      .isSignatureUploaded()
      .then((json) => {
        dispatch({
          type: IS_SIGNATURE_UPLOADED_STATUS,
          payload: {
            isSignatureUploaded: json?.data?.is_signature_uploaded,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: IS_SIGNATURE_UPLOADED_STATUS,
          payload: { message: errorMessage(error) },
        });
      });
  };
};

export const updateType = (type) => {
  return (dispatch) => {
    dispatch({
      type: UPDATE_FILTER,
      payload: type,
    });
  };
};
